import React from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row} from 'antd'
import _ from 'lodash'
import styles from './styles.less'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request from '../../request'
import {connect} from 'react-redux'

@Form.create()
class CommunicationSms extends React.Component {
    state = {
        visible: true,
        templateArr: [],
        loading: false,
        mobileNumberList: ''
    }
    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('SMS')
        this.setState({templateArr})
    }
    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values.usersData = this.props.counsellingData.usersData
                dispatch(showLoader())

                let x = await Request.sendSmsByTemplate(values)

                if (x.error) {
                    notification.warning({
                        message: x.msg
                    })
                } else {
                    notification.success({
                        message: x.msg
                    })
                    this.onClose();
                }

                dispatch(hideLoader());

            }
        })
    }

    componentDidMount() {
        this.loadSmsTemplate()
        let mobileNumberList = ''
        let sliceUser = []
        if (this.props.counsellingData.usersData) {
            sliceUser = this.props.counsellingData.usersData.slice(0, 30)
            _.each(sliceUser, (item, key) => {
                if (item.mobile) {
                    mobileNumberList += item.mobile + (sliceUser.length - 1 === key ? '' : ', ')
                }
            })
            if (this.props.counsellingData.usersData.length > 30) {
                mobileNumberList += '...'
            }
        }
        setTimeout(() => {
            this.setState({mobileNumberList})
        }, 500)
    }

    render() {
        const {
            form: {getFieldDecorator}
        } = this.props
        const {templateArr} = this.state

        const inputSchema2 = {
            fields: [
                {
                    label: 'Choose Template',
                    key: 'counsellorId',
                    type: 'select',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    width: 500,
                    keyAccessor: x => x.templateData,
                    valueAccessor: x => x.templateName,
                    disabled: false,
                    options: templateArr ? templateArr : {},
                    onChange: v => {
                        this.props.form.setFieldsValue({counsellorId: v})
                        this.props.form.setFieldsValue({template: v})
                    }
                },
                {
                    label: 'Template ',
                    key: 'template',
                    required: true,
                    type: 'editors',
                    rows: 15
                }
            ]
        }

        return (
            <Drawer
                title={
                    <div>
                        SMS {' '}
                        <button onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'cross'}/>
                        </button>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>

                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <div className={styles.toFields}>
                            <React.Fragment> To </React.Fragment> : <React.Fragment>{this.state.mobileNumberList}</React.Fragment>
                        </div>
                        <div className={styles.formDiv}>
                            <GetAllFormFields
                                inputSchema={inputSchema2}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>

                        <Row>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Send
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>


                </Card>

            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommunicationSms)
